/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ObtenerInformacionAdicionalPrestamoMS { 
    oficina?: string | null;
    oficial?: string | null;
    ultimoPago?: string | null;
    proximoVencimiento?: string | null;
    numeroCuotasVencidas?: number | null;
    valorCancelar?: number | null;
    valorTotalCuota?: number | null;
    valorHastaCuotaActual?: number | null;
    saldoActual?: number | null;
    cuotasCanceladas?: number;
}

